import { useCallback, useEffect, useMemo, useState } from "react";

export const useVersionedChapters = (initialChaptersUrl?: string) => {
  const [baseChaptersUrl, setBaseChaptersUrl] = useState(initialChaptersUrl);
  const [version, setVersion] = useState<number | null>(null);

  useEffect(() => {
    setBaseChaptersUrl(initialChaptersUrl);
    setVersion(null);
  }, [initialChaptersUrl]);

  const updateChaptersUrl = useCallback((nextChaptersUrl?: string | null) => {
    setBaseChaptersUrl(nextChaptersUrl ?? undefined);
    if (nextChaptersUrl) {
      setVersion(Date.now());
    } else {
      setVersion(null);
    }
  }, []);

  const versionedChaptersUrl = useMemo(() => {
    if (!baseChaptersUrl) return undefined;
    if (!version) return baseChaptersUrl;
    const separator = baseChaptersUrl.includes("?") ? "&" : "?";
    return `${baseChaptersUrl}${separator}v=${version}`;
  }, [baseChaptersUrl, version]);

  const chaptersRenderKey = useMemo(() => {
    const baseKey = baseChaptersUrl ?? "no-chapters";
    return `${baseKey}:${version ?? 0}`;
  }, [baseChaptersUrl, version]);

  return {
    versionedChaptersUrl,
    updateChaptersUrl,
    chaptersRenderKey,
  };
};
